import { DerivedAvailabilityStatus, DerivedAvailabilityStatusInternal } from '@commerce-product-webcomponents/sdk';
import { DerivedAvailabilityStatusComponentGroupKey } from './types/enums';
import { bundleDerivedStockStatusPriority } from './types/propsTypes';

// Return the highest priority bundle stock status as per priority decided
export const checkPriorityBundleStatus = (
  statusArray: Array<DerivedAvailabilityStatusInternal>,
): DerivedAvailabilityStatusInternal => {
  const priortizedList = statusArray.sort(
    (a, b) => bundleDerivedStockStatusPriority.indexOf(a) - bundleDerivedStockStatusPriority.indexOf(b),
  );
  return priortizedList[0];
};

const groupedStockStatus = {
  [DerivedAvailabilityStatusComponentGroupKey.NOT_AVAILABLE_STATUSES as string]: [
    DerivedAvailabilityStatus.Nla,
    DerivedAvailabilityStatus.Naw,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.AVAILABLE_IN_FEW_STOCKS as string]: [
    DerivedAvailabilityStatus.LowStock,
    DerivedAvailabilityStatus.Bo,
    DerivedAvailabilityStatusInternal.ExclusiveForYou,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.CTA_DISABLED_STATUSES as string]: [
    DerivedAvailabilityStatus.OutOfStock,
    DerivedAvailabilityStatus.Nla,
    DerivedAvailabilityStatus.Nya,
    DerivedAvailabilityStatus.Naw,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.CTA_ENABLED_STATUSES as string]: [
    DerivedAvailabilityStatus.InStock,
    DerivedAvailabilityStatus.Bo,
    DerivedAvailabilityStatus.LowStock,
    DerivedAvailabilityStatusInternal.ExclusiveForYou,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.DISPOSITION_STATUSES as string]: [
    DerivedAvailabilityStatus.OutOfStock,
    DerivedAvailabilityStatus.Nla,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.CTA_DISABLED_SUBSCRIPTION_STATUSES as string]: [
    DerivedAvailabilityStatus.Nya,
    DerivedAvailabilityStatus.Nla,
  ],
  [DerivedAvailabilityStatusComponentGroupKey.PRE_LAUNCH_IGNORE_STATUSES as string]: [
    DerivedAvailabilityStatusInternal.Nya,
    DerivedAvailabilityStatusInternal.OutOfStock,
    DerivedAvailabilityStatusInternal.Nla,
  ],
};

export const includesDerivedAvailabilityStockStatus = (
  status: string,
  key: string = DerivedAvailabilityStatusComponentGroupKey.NOT_AVAILABLE_STATUSES,
): boolean => {
  const stockArr = groupedStockStatus[key] as string[];
  return stockArr.includes(status);
};

export const checkIfProductIsNya = (status: DerivedAvailabilityStatusInternal): boolean =>
  status === DerivedAvailabilityStatusInternal.Nya;

export { DerivedAvailabilityStatusComponentGroupKey };
